import Carousel from "./Component/Carousel/CustomSlider"
function App() {
  return (
    <>
     <Carousel />
    </>
  );
}

export default App;
